module.exports = __webpack_public_path__ + "img/rent.3f6d9945.png";